import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import Calendar, { DispatchProps, OwnProps, StateProps } from './CalendarTab';

import { StoreState } from 'src/store/reducers';
import { getCase, updateCase } from 'src/store/actions/case-actions';
import { getSeances } from 'src/store/actions/seance-actions';
import { getCases } from 'src/store/actions/case-actions';
import { QueryParams } from 'src/types/grid';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        inProgress: state.cases.inProgress,
        inProgressSeances: state.seances.inProgress,
        caseEnt: state.cases.current,
        seances: state.seances.data,
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getCaseData: (id) => dispatch(getCase(id)),
        getData: (params: QueryParams) => dispatch(getSeances(params)),
        getCases: (params: QueryParams) => dispatch(getCases(params)),
        updateCaseAction: (data) =>
            dispatch(
                updateCase(
                    data,
                    () => false,
                    (errorMessage: string) => {
                        toast.error(errorMessage);
                    },
                ),
            ),
    };
}

const CalendarTab = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(Calendar);

export default CalendarTab;
